import sdl from '@jds/react-generated-sdl/JDSDropdownMenuItemMobile';
import type { JDSDropdownMenuItemMobileProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDropdownMenuItemMobileProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    selected = false,
    disabled = false,
    ariaLabel = props.label?.toString(),
    _ariaHaspopup = props._hasSubMenu?.toString(),
    _ariaExpanded = props.selected?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { selected, disabled, ariaLabel, _ariaHaspopup, _ariaExpanded, ...rest },
    'JDSDropdownMenuItemMobile',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DropdownMenuItemMobile = withLogic(
  Component
) as React.FC<JDSDropdownMenuItemMobileProps> & { slotName?: string };

DropdownMenuItemMobile.displayName = 'DropdownMenuItemMobile';
DropdownMenuItemMobile.slotName = 'jds_dropdown_menu_item_mobile';

export { DropdownMenuItemMobile, type JDSDropdownMenuItemMobileProps };
